import React from "react";
import { useEffect, useState } from "react";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import SelectSearchBox from "../../common/SelectBoxSearch";
import moment from "moment";
import Notifications from "../../../components/common/Notifications";
const useEnableEmployeeListAppraisal = (empArr, handleSelectedEmp,empList,handleChangemain,activeTab,handleUpdate,enabledemployeelist) => {
  const [trow, setTrow] = useState([]);
  const [selectedReviewer, setselectedReviewer] = useState([]);
const [emplist, setEmplist] = useState([]);
   const[activetabh,setactivetabh] =useState(0);
  const [errorhook, setErrorhook] = useState(null);

  useEffect(() => {
    setactivetabh(activeTab);
  if (empArr && empArr.length > 0) {
    setEmplist(empArr.map(emp => ({ ...emp })));
  }
}, [empArr,activeTab]);
 //   Functiions ------------------
const selectedUserFromSearch = React.useCallback(
  (emp, type, rowId, appraiseeId) => {
    const rows = emplist.map(row => ({ ...row }));
    const currentRow = { ...rows[rowId] };

    const reviewerId = emp.empId;

    // 🚫 Prevent same reviewer for both roles
    if (
      (type === 1 && currentRow.reviewer2 === reviewerId) ||
      (type === 2 && currentRow.reviewer1 === reviewerId)
    ) {
   setErrorhook(null);

  alert("Reviewer 1 and Reviewer 2 cannot be the same employee");



      return;
    }

    if (type === 1) {
      currentRow.reviewer1 = reviewerId;
      currentRow.reviewer1Obj = emp;
    } else {
      currentRow.reviewer2 = reviewerId;
      currentRow.reviewer2Obj = emp;
    }

    currentRow.appraiseeId = appraiseeId;
    rows[rowId] = currentRow;

    setEmplist([...rows]);
    handleChangemain(appraiseeId, rows);
  },
  [emplist, handleChangemain, setErrorhook]
);





const handleChange = React.useCallback((evnt,rowId,employeeId) => {  
  
 const rowsInput = emplist.map(row => ({ ...row }));
  if(rowsInput.length > 0){
   
      rowsInput[rowId].isEnabled = evnt.target.checked;
  
  }
  setEmplist(rowsInput);
  handleChangemain(employeeId,rowsInput);
},[handleChangemain,setEmplist,emplist]);
  useEffect(() => {
   if (!emplist) return;
   let trow=[];


    trow =activetabh == '1' ? (emplist.map((employee, i) => {
       const isAlreadyEnabled = enabledemployeelist.some(
  (item) => item.employeeId === employee.employeeId
);
      return {
        Select: (
        <div>
         
            <input type="checkbox" key={i} onChange={(evnt)=>handleChange(evnt,i,employee.employeeId)} style={{ color: 'green'}}  checked={employee.isEnabled === true && !isAlreadyEnabled} disabled={isAlreadyEnabled}></input>
          
         
        </div>),
        Id: <div disabled={employee.isEnabled ==true? true : false} hidden={true}>{employee.employeeId}</div>,
 Code: <div disabled={employee.isEnabled ==true? true : false}>{employee.employeeCode}</div>,
        Name: (
          <h2
          className="table-avatar"
            // onClick={() => handleSelectedEmp(employee)}
            disabled={employee.isEnabled ==true? true : false}
          >
            <img
              className="profile-img-table"
              alt=""
              src={employee.profilePicture == null || employee.profilePicture == "null" || employee.profilePicture =='undefined'? (require(`../../../img/employee/user.png`)) : (`https://niraconnect.nirasystems.com:8080/wwwroot/UploadedPhotos/ProfilePicture/${employee.profilePicture}`)}
            />
            <span className="ml-2">
              <span style={{ fontWeight: "400", color: "black",fontSize:"14px" }}>
                {employee.employeeName}
              </span>
              <span> {employee.designationName}</span>
            </span>
          </h2>
        ),
        EligibilityStatus: <div disabled={employee.isEnabled ==true? true : false}>{employee.dueOn =="0" ? "Not Eligible" :employee.dueOn}</div>,
        JoiningDate: <div disabled={employee.isEnabled ==true? true : false}>{moment(employee.dateOfJoin).format("DD-MM-YYYY")}</div>,
        LastReview: <div disabled={employee.isEnabled ==true? true : false}>{moment(employee.reviewDate).format("DD-MM-YYYY")}</div>,
        // DueOn: <div>{employee.dueOn}</div>,
        Reviewer1: (
         
            (<div disabled={true}>
                <SelectSearchBox
                options={empList}
                onChange={(user) =>selectedUserFromSearch(user,1,i,employee.employeeId)}
               selectedUser={
              employee.reviewer1Obj || empList.find(n => n.empId === employee.reviewer1) || ""
            }
              ></SelectSearchBox>
            </div>)
       
         ),
         Reviewer2:(
         
            (<div disabled={true}>
               <SelectSearchBox
                options={empList}
                onChange={(user) =>selectedUserFromSearch(user,2,i,employee.employeeId)}
             selectedUser={
              employee.reviewer2Obj || empList.find(n => n.empId === employee.reviewer2) || ""
            }
             ></SelectSearchBox>
            </div>)
       
         )
          
      };
    })) : (emplist.map((employee, i) => {
      const isAlreadyEnabled = enabledemployeelist.some(
  (item) => item.employeeId === employee.employeeId
);
      return {
        Select: (
        <div>
    
            <input type="checkbox" key={i} onChange={(evnt)=>handleChange(evnt,i,employee.employeeId)} checked={employee.isEnabled === true && !isAlreadyEnabled} ></input>
          
         
        </div>),
        Id: <div>{employee.employeeId}</div>,
Code: <div disabled={employee.isEnabled ==true? true : false}>{employee.employeeCode}</div>,
        Name: (
          <h2
          className="table-avatar"
            onClick={() => handleSelectedEmp(employee)}
          >
            <img
              className="profile-img-table"
              alt=""
              src={employee.profilePicture == null || employee.profilePicture == "null" || employee.profilePicture =='undefined'? (require(`../../../img/employee/user.png`)) : (`https://niraconnect.nirasystems.com:8080/wwwroot/UploadedPhotos/ProfilePicture/${employee.profilePicture}`)}
            />
            <span className="ml-2">
              <span style={{ fontWeight: "400", color: "black",fontSize:"14px" }}>
                {employee.employeeName}
              </span>
              <span> {employee.designationName}</span>
            </span>
          </h2>
        ),
        EligibilityStatus: <div>{employee.dueOn =="0" ? "Not Eligible" :employee.dueOn}</div>,
        JoiningDate: <div>{moment(employee.dateOfJoin).format("DD-MM-YYYY")}</div>,
        LastReview: <div>{moment(employee.reviewDate).format("DD-MM-YYYY")}</div>,
        Status:<div>{employee.status}</div>,
        // DueOn: <div>{employee.dueOn}</div>,
        Reviewer1: (
         
            (<div style={{width:"150px"}}>
                <SelectSearchBox
                options={empList}
                onChange={(user) =>selectedUserFromSearch(user,1,i,employee.employeeId)}
               selectedUser={
              employee.reviewer1Obj || empList.find(n => n.empId === employee.reviewer1) || ""
            }
              ></SelectSearchBox>
            </div>)
       
         ),
         Reviewer2:(
         
            (<div style={{width:"150px"}}>
               <SelectSearchBox
                options={empList}
                onChange={(user) =>selectedUserFromSearch(user,2,i,employee.employeeId)}
                   selectedUser={
              employee.reviewer2Obj || empList.find(n => n.empId === employee.reviewer2) || ""
            }
              ></SelectSearchBox>
            </div>)
       
         ),

         Action:(<div><Button  color=""
          className="btn-admin-settings"
          onClick={() => handleUpdate(employee)}
          >Update</Button></div>
         )
          
      };
    }));

    setTrow(trow.length >0 ? trow : []);
  }, [emplist, handleSelectedEmp,empList]);

  return {  trow ,errorhook, setErrorhook};
    
};

export default useEnableEmployeeListAppraisal;